/** @format */

import axios from 'axios';
import { VegaUser } from '../types/user';
import {
  AddCognitoUserForClientParams,
  IRolesProps,
  IUsersProps,
} from '../types/userAccess';
import { BASE_URL, ROLE_MANAGEMENT } from './endpoints';

const ROLE_MANAGEMENT_BASE_URL = BASE_URL + ROLE_MANAGEMENT.BASE;

export const fetchListOfUsersForClient = (clientId: string | null) => {
  return axios.get(`${ROLE_MANAGEMENT_BASE_URL}/listUsersByClient/${clientId}`);
};

export const fetchListOfRolesForClient = (clientId: string | null) => {
  return axios.get(
    `${ROLE_MANAGEMENT_BASE_URL}/listRolesForClient/${clientId}`
  );
};
export const addUserForClient = (user: IUsersProps) => {
  return axios.post(`${ROLE_MANAGEMENT_BASE_URL}/addUser`, user);
};
export const addRoleForClient = (data: IRolesProps) => {
  return axios.post(`${ROLE_MANAGEMENT_BASE_URL}/addRole`, data);
};
export const updateRoleForClient = (data: any) => {
  return axios.put(`${ROLE_MANAGEMENT_BASE_URL}/updateRole`, data);
};

export const addRoleForUser = (data: any) => {
  return axios.post(`${ROLE_MANAGEMENT_BASE_URL}/addRoleForUser`, data);
};
export const updateRoleForUser = (data: any) => {
  return axios.put(`${ROLE_MANAGEMENT_BASE_URL}/updateRoleForUser`, data);
};

export async function getUserByEmail(data: {
  email: string;
}): Promise<VegaUser> {
  const endpoint =
    ROLE_MANAGEMENT_BASE_URL +
    ROLE_MANAGEMENT.GET_BY_EMAIL.replace('{email}', data.email);
  try {
    const response = await axios.get(endpoint);
    return response.data as VegaUser;
  } catch (error) {
    throw error;
  }
}

export async function addCognitoUserForClient(
  data: AddCognitoUserForClientParams
): Promise<VegaUser> {
  const endpoint = ROLE_MANAGEMENT_BASE_URL + ROLE_MANAGEMENT.ADD_COGNITO_USER;
  try {
    const response = await axios.post(endpoint, data);
    return response.data as VegaUser;
  } catch (error) {
    throw error;
  }
}

export const addOrUpdateRolesForUser = (updateUserRoleRequest: any) => {
  return axios.put(
    `${ROLE_MANAGEMENT_BASE_URL}${ROLE_MANAGEMENT.UPDATE_ROLE_FOR_USER}`,
    updateUserRoleRequest
  );
};

////////////////////// Bulk Upload \\\\\\\\\\\\\\\\\\\\
export const bulkProcessForUser = (formData: any) => {
  return axios.post(`${ROLE_MANAGEMENT_BASE_URL}/bulk/user/process`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const bulkSaveForUser = (data: any) => {
  return axios.post(`${ROLE_MANAGEMENT_BASE_URL}/bulk/user/save`, data);
};

export const fetchPastUploadForUser = (clientId: string) => {
  return axios.post(
    `${ROLE_MANAGEMENT_BASE_URL}/bulk/past/uploads/${clientId}`
  );
};
////////////////////// Bulk Upload \\\\\\\\\\\\\\\\\\\\
